import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start gap-4" }
const _hoisted_2 = { class: "el-upload__text" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = { class: "d-flex align-items-center mb-3" }
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_9 = { class: "mb-5" }
const _hoisted_10 = {
  class: "p-4 border rounded-2 bg-light",
  style: {"min-width":"280px"}
}
const _hoisted_11 = { class: "d-flex align-items-center gap-2 mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "🤖 For Android", -1)
const _hoisted_13 = { class: "ms-2 text-muted small" }

import { ref } from "vue";
import { useStore } from "@/store";
import type { UploadUserFile } from "element-plus";
import { UploadFilled } from "@element-plus/icons-vue";
import { Delete } from "@element-plus/icons-vue";
import ItServices from "../../services/ItServices";
import notification from "@/core/plugins/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadPublicFileModal',
  setup(__props) {

const isLoading = ref(false);
const isAndroidLoading = ref(false);
const fileList = ref<UploadUserFile[]>([]);
const store = useStore();
const user = store.state.AuthModule.user;
const uploadedLinks = ref<string[]>([]);
const forAndroid = ref(false);
const androidForm = ref({ version: "", isForceUpdate: false, url: "" });
const operatorInfo = ref<any>({
  name: user.nativeName,
  email: user.email,
  updatedAt: new Date().toISOString(),
});

const submitUpload = async () => {
  isLoading.value = true;
  try {
    const formData = new FormData();
    fileList.value.forEach((file) => {
      formData.append("files[]", file.raw);
      formData.append("fileNames[]", file.name);
    });
    formData.append("operatorInfo", JSON.stringify(operatorInfo.value));
    const res = await ItServices.uploadPublicFiles(formData);
    if (res) {
      notification.success();
      fileList.value = [];
      uploadedLinks.value = res;
      if (forAndroid.value && res.length > 0) {
        androidForm.value.url = res[0];
      }
    }
  } catch (e) {
    notification.danger();
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

const handleRemove = (file: UploadUserFile) => {
  fileList.value = fileList.value.filter((f) => f !== file);
};

const submitAndroidUpdate = async () => {
  isAndroidLoading.value = true;
  try {
    const payload: Record<string, any> = {};
    if (androidForm.value.version) payload.version = androidForm.value.version;
    if (androidForm.value.url) payload.url = androidForm.value.url;
    payload.isForceUpdate = androidForm.value.isForceUpdate;
    await ItServices.updateAndroidVersion(payload);
    notification.success();
  } catch (e) {
    notification.danger();
    console.log(e);
  } finally {
    isAndroidLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_upload, {
        "file-list": fileList.value,
        "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
        "auto-upload": false,
        disabled: isLoading.value,
        class: "w-350px",
        "show-file-list": false,
        multiple: "",
        drag: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFilled))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                innerHTML: _ctx.$t('fields.dropFileHereOrClickHere')
              }, null, 8, _hoisted_3)
            ])
          ])
        ]),
        _: 1
      }, 8, ["file-list", "disabled"]),
      (fileList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("fields.previewLinks")), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_input, {
                    modelValue: file.name,
                    "onUpdate:modelValue": ($event: any) => ((file.name) = $event),
                    disabled: isLoading.value,
                    style: {"max-width":"1100px"}
                  }, {
                    prepend: _withCtx(() => [
                      _createTextVNode("https://bcrpropublic.s3.ap-southeast-1.amazonaws.com/")
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
                  _createVNode(_component_el_button, {
                    onClick: ($event: any) => (handleRemove(file)),
                    disabled: isLoading.value,
                    class: "ms-4",
                    icon: _unref(Delete),
                    circle: "",
                    type: "danger",
                    size: "small"
                  }, null, 8, ["onClick", "disabled", "icon"])
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_button, {
          onClick: submitUpload,
          loading: isLoading.value,
          disabled: fileList.value.length <= 0,
          type: "success",
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.clickToUpload")), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      (uploadedLinks.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_el_divider),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("fields.uploadedFileLinks")), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedLinks.value, (link, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_el_link, {
                  href: link,
                  target: "_blank",
                  type: "primary",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(link), 1)
                  ]),
                  _: 2
                }, 1032, ["href"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_switch, {
          modelValue: forAndroid.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((forAndroid).value = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_12
      ]),
      (forAndroid.value)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Version" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: androidForm.value.version,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((androidForm.value.version) = $event)),
                    placeholder: "e.g. 1.2.3"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Force Update" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: androidForm.value.isForceUpdate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((androidForm.value.isForceUpdate) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(androidForm.value.isForceUpdate ? "Yes" : "No"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "URL" }, {
                default: _withCtx(() => [
                  (uploadedLinks.value.length > 0)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: androidForm.value.url,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((androidForm.value.url) = $event)),
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedLinks.value, (link, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: link,
                              value: link
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        modelValue: androidForm.value.url,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((androidForm.value.url) = $event)),
                        placeholder: "https://..."
                      }, null, 8, ["modelValue"]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                loading: isAndroidLoading.value,
                onClick: submitAndroidUpdate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Submit Android Update ")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})